<template>
  <el-dialog :visible.sync="visible" width="500px" :close-on-click-modal="false" append-to-body @open="onModalOpen">
    <template #title>
      <span style="font-size: 18px">媒体素材管理账号配置</span>
      <el-tooltip placement="right">
        <div slot="content" class="tooltip-content">
          <p>1、该功能用于设计师进行【素材上传】时，会同步上传到媒体的账号的素材库。然后通过该【素材库】共享到其他账号。</p>
          <p>
            2、【巨量引擎】：根据【视频】还是【图片/封面】设置不同的账号。【视频】通过工作台上传，只设置一个管家账号；【图片/封面】可以以设置多个【管家账号】类型账号
          </p>
          <p>3、【腾讯】可以设置多个【管家账号】类型账号。</p>
        </div>
        <i class="el-icon-question tip-icon"></i>
      </el-tooltip>
    </template>

    <el-form label-width="100px" class="config-form">
      <el-form-item label="巨量引擎">
        <div class="jl-item">
          <span class="item-label">视频素材&ensp;</span>
          <el-select v-model="form.ttVideoAccountIds" filterable placeholder="请选择账号（单选）" clearable>
            <el-option v-for="item in jlAccountList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>

          <el-tooltip placement="right">
            <div slot="content" class="tooltip-content">
              <p>说明：【视频素材】一般选择的账号是【新版工作台】的工作台账号</p>
            </div>
            <i class="el-icon-question tip-icon"></i>
          </el-tooltip>
        </div>

        <div class="jl-item">
          <span class="item-label">图片/视频封面&ensp;</span>
          <el-select v-model="form.ttImageAccountIds" multiple filterable placeholder="请选择账号（可多选）" clearable>
            <el-option v-for="item in jlAccountList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>

          <el-tooltip placement="right">
            <div slot="content" class="tooltip-content">
              <p>说明：【图片/视频封面】一般选择的账号是各个主体账号的管家账号。</p>
            </div>
            <i class="el-icon-question tip-icon"></i>
          </el-tooltip>
        </div>
      </el-form-item>

      <el-form-item label="腾讯">
        <div style="display: flex; align-items: center">
          <el-select v-model="form.gdtAccountIds" multiple filterable placeholder="请选择账号（可多选）" style="width: 100%" clearable>
            <el-option v-for="item in txAccountList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>

          <el-tooltip placement="right">
            <div slot="content" class="tooltip-content">
              <p>说明：腾讯【图片/视频/组图】一般选择的账号是各个主体的【业务单元账号】。</p>
            </div>
            <i class="el-icon-question tip-icon"></i>
          </el-tooltip>
        </div>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script setup>
import { ref, computed } from 'vue'
import { MEDIAS } from '@/common/js/constants'
import { getImageUploadManageAccountConfig } from '@/api/sysmana.model'

const getForm = () => {
  return {
    ttVideoAccountIds: '',
    ttImageAccountIds: [],
    gdtAccountIds: []
  }
}
// eslint-disable-next-line
const props = defineProps({
  value: {
    type: Boolean,
    default: false
  },

  loading: {
    type: Boolean,
    default: false
  },
  manageAccounts: {
    type: Array,
    default: () => []
  }
})
// eslint-disable-next-line
const emit = defineEmits(['input', 'confirm'])

const jlAccountList = computed(() => props.manageAccounts.filter((ac) => ac.mediaId === MEDIAS.TOUTIAO))
const txAccountList = computed(() => props.manageAccounts.filter((ac) => ac.mediaId === MEDIAS.GDT))

const form = ref({ ...getForm() })

const onModalOpen = () => {
  getImageUploadManageAccountConfig().then((data) => {
    if (data) {
      const [ttVideoId] = data.ttVideoAccountIds || []
      form.value = { ...data, ttVideoAccountIds: ttVideoId || '' }
    }
  })
}

const visible = computed({
  get() {
    return props.value
  },
  set(val) {
    emit('input', val)
  }
})

const handleClose = () => {
  visible.value = false
  form.value = getForm()
}

const handleConfirm = () => {
  emit('confirm', { ...form.value })
}
</script>

<style lang="scss" scoped>
.tooltip-content {
  max-width: 300px;
  line-height: 1.5;
  p {
    margin-bottom: 5px;
  }
}
.tip-icon {
  margin-left: 5px;
  font-size: 16px;
  cursor: pointer;
  color: #999;
}
.config-form {
  .jl-item {
    margin-bottom: 10px;
    display: flex;
    align-items: center;

    .item-label {
      width: 100px;
      text-align: right;
      font-size: 12px;
    }

    .el-select {
      flex: 1;
    }
  }
}
</style>
